import { ViewId } from "../common/formId";
import { DeleteAccountConfirm } from "../deleteAccountConfirm/delete-account-confirm";
import { DeviceLogin } from "../deviceLogin/device-login";
import { EmailCodeForm } from "../email-code-form";
import { ErrorScreen } from "../error";
import { LinkDeviceAccount } from "../linkDeviceAccount/link-device-account";
import { Login } from "../login";
import { LoginConfirmation } from "../login-confirmation";
import { LoginIdpLinkConfirm } from "../login-idp-link-confirm";
import { LoginIdpUpdateProfile } from "../login-idp-update-profile";
import { LoginOauthGrant } from "../loginOauthGrant/login-oauth-grant";
import { Register } from "../register";
import { RegisterStart } from "../register-start";
import { UpdateEmail } from "../updateEmail/update-email";
export const ViewModuleMap = {
    [ViewId.Login]: Login,
    [ViewId.RegistrationStart]: RegisterStart,
    [ViewId.RegistrationContinue]: Register,
    [ViewId.RegistrationSuccess]: null,
    [ViewId.IdpRegistrationConfirmLinking]: LoginIdpLinkConfirm,
    [ViewId.IdpRegistrationUpdateProfile]: LoginIdpUpdateProfile,
    [ViewId.OneTimePassword]: EmailCodeForm,
    [ViewId.DeleteAccountConfirm]: DeleteAccountConfirm,
    [ViewId.UpdateEmail]: UpdateEmail,
    [ViewId.DeviceLoginConfirmation]: LinkDeviceAccount,
    [ViewId.DeviceLoginCode]: DeviceLogin,
    [ViewId.DeviceLoginSuccess]: null,
    [ViewId.DeviceLoginDenied]: null,
    [ViewId.LoginConfirmation]: LoginConfirmation,
    [ViewId.Error]: ErrorScreen,
    [ViewId.Info]: null,
    [ViewId.LoginOauthGrant]: LoginOauthGrant
};
